import { Action } from "redux";
import notificationTypes from "./notificationTypes";

export type NotifType = "info" | "success" | "warning" | "error" | "default";

interface INotification {
  payload: {
    open?: boolean;
    type: NotifType;
    message: string;
  };
}

export type OpenNotificationAction = INotification &
  Action<notificationTypes.Open_Notification>;

export const openNotificationAction = (
  message: INotification["payload"]["message"],
  type: INotification["payload"]["type"]
): OpenNotificationAction => ({
  type: notificationTypes.Open_Notification,
  payload: { message, type, open: true },
});

export type CloseNotificationAction = INotification &
  Action<notificationTypes.Close_Notification>;

export const closeNotificationAction = (): CloseNotificationAction => ({
  type: notificationTypes.Close_Notification,
  payload: {
    message: "",
    type: "default",
    open: false,
  },
});

export type NotificationActions =
  | OpenNotificationAction
  | CloseNotificationAction;
